import { useContext } from 'react';
import {
    CustomAlarmsListContext,
    CustomAlarmsListContextProps,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/contexts/custom-alarms-list.context';

export const useCustomAlarmsListContext = () => {
    const context = useContext<CustomAlarmsListContextProps | undefined>(CustomAlarmsListContext);

    if (!context) {
        throw new Error('useCustomAlarmsListContext must be used inside a CustomAlarmsListProvider');
    }

    return context;
};
